<template>
  <section class="project-connect--content">
    <div class="hide--in-tablet hide--in-desktop" v-if="!isShortlist">
      <button type="button" @click="openFilterSidebar()" class="btn filter--btn">
        <v-icon class="icon-filter">mdi-filter</v-icon>Filter
      </button>
    </div>

    <div class="state--box" v-if="locked">
      {{ lockedMessage }}
    </div>
    <div class="state--box error" v-else-if="error">
      {{ error }}
    </div>
    <div class="state--box" v-else-if="!loading && projects.length === 0">
      {{ emptyText }}
    </div>

    <div :class="['project-connect--grid', { 'is-shortlist': isShortlist }]" v-else>
      <div v-for="project in projects" :key="cardKey(project)" class="project--item">
        <project-card
          :project="project"
          :is-shortlist="isShortlist"
          :loading="actionLoadingId === actionId(project)"
          @show-contact="$emit('show-contact', $event)"
          @open-whatsapp="$emit('open-whatsapp', $event)"
          @remove="$emit('remove', $event)"
        />
      </div>
    </div>

    <pagination
      v-if="meta && meta.pagination && !locked && !error"
      :push-state="false"
      :meta="meta.pagination"
      @changePage="$emit('change-page', $event)"
      :maxVisibleButtons="5"
      class="mb-2"
    />
  </section>
</template>

<script>
import ProjectCard from '@/components/project-connect/project-card.vue';
import Pagination from '@/components/utils/fractal-pagination.vue';

export default {
  name: 'project-connect-content',
  components: {
    ProjectCard,
    Pagination,
  },
  props: {
    projects: {
      default: () => [],
    },
    meta: {
      default: null,
    },
    loading: {
      default: false,
    },
    locked: {
      default: false,
    },
    error: {
      default: null,
    },
    isShortlist: {
      default: false,
    },
    emptyText: {
      default: 'Data tidak ditemukan.',
    },
    actionLoadingId: {
      default: null,
    },
  },
  data() {
    return {
      lockedMessage:
        'Project Connect hanya tersedia untuk agen dengan membership PRO atau EXECUTIVE aktif.',
    };
  },
  methods: {
    actionId(project) {
      return this.isShortlist ? project.project_id : project.id;
    },
    cardKey(project) {
      return this.isShortlist ? project.id : project.id;
    },
    openFilterSidebar() {
      this.$store.commit('searchListing/SET_ACTIVE_FILTER_SIDEBAR', true);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/utils/variables';

.project-connect--grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  &.is-shortlist {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media #{$phones, $tablets} {
    grid-template-columns: 1fr;
  }

  @media #{$tablets} {
    &.is-shortlist {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media #{$phones} {
    &.is-shortlist {
      grid-template-columns: 1fr;
    }
  }
}

.filter--btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 14px;
  background-color: #ffffff !important;
  border: 1px solid #e7e7e7;
  color: #333333 !important;
  margin-bottom: 16px;
  border-radius: 12px;
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 13px;
  box-shadow: 0 8px 18px rgba(33, 33, 33, 0.06);

  .icon-filter {
    color: $color-beliruma-1;
    margin-right: 8px;
    font-size: 18px;
  }
}

.state--box {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  color: #555555;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);

  &.error {
    color: #8b0000;
  }
}
</style>
